module.exports = __webpack_public_path__ + "img/logo-vuejs-min.08f0c81f.png";